module.exports = __webpack_public_path__ + "img/nm_home_header_illustration1.b61c6ac8.png";